import React from "react";
import Formik from "./FormikWithRef";

const Form = React.forwardRef(
  ({ children, className, noFormTag, ...rest }, ref) =>
    noFormTag ? (
      <Formik
        validateOnChange
        validateOnBlur
        enableReinitialize
        {...rest}
        ref={ref}
      >
        {() => children}
      </Formik>
    ) : (
      <Formik
        validateOnChange
        validateOnBlur
        enableReinitialize
        {...rest}
        ref={ref}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className={className} noValidate>
            {children}
          </form>
        )}
      </Formik>
    )
);

export default Form;
